import { useCallback, useMemo } from 'react';

import { useGetClientSubscriptionsQuery } from '@app/api/Subscriptions';
import { groupClientSubscriptions } from '@app/components/RecordModal/components/RecordDetails/components/ClientSubscriptions/utils';
import { WARNING } from '@app/constants';
import { useNotification } from '@app/providers/NotificationProvider/NotificationContext';

interface UseClientSubscriptionsProps {
  clientId: number | null;
  activeBranchId: number | null;
}

/**
 * Абонементы клиента записи со свободными услугами (GetClientSubscriptions).
 * Пока клиент не выбран, запрос не уходит.
 */
export const useClientSubscriptions = ({
  clientId,
  activeBranchId,
}: UseClientSubscriptionsProps) => {
  const { showNotification } = useNotification();

  // currentData — ответ только для текущих аргументов. data держит ответ по
  // прошлому клиенту до прихода нового и показал бы чужие абонементы.
  const { currentData, error } = useGetClientSubscriptionsQuery(
    { ActiveBranchId: activeBranchId, clientId: clientId ?? 0 },
    { skip: !clientId || activeBranchId === null }
  );

  // Повторный запрос с ошибкой оставляет в currentData прошлый ответ: при
  // ошибке абонементы не показываем, остаток мог измениться.
  const subscriptions = useMemo(
    () => groupClientSubscriptions(error ? undefined : currentData),
    [currentData, error]
  );

  const showErrorHandler = useCallback(
    (requestError: unknown) => showNotification(requestError, WARNING),
    [showNotification]
  );

  return { subscriptions, error, showErrorHandler };
};
